import { Link, useLocation } from 'react-router';
import { Home, User, LogOut } from 'lucide-react';
import { cn } from '../../lib/utils';

interface SidebarProps {
  onLogout: () => void;
}

export function ResidentSidebar({ onLogout }: SidebarProps) {
  const location = useLocation();
  const pathname = location.pathname;

  const links = [
    { href: '/dashboard', label: 'Dashboard', icon: Home },
    { href: '/dashboard/profile', label: 'Profile', icon: User },
  ];

  return (
    <aside className="flex h-full w-64 flex-col bg-sidebar border-r border-sidebar-border shrink-0">
      <div className="flex items-center gap-3 px-5 h-16">
        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-sidebar-primary">
          <span className="text-sidebar-primary-foreground font-semibold">U</span>
        </div>
        <span className="text-sidebar-foreground font-semibold">UniDom</span>
      </div>

      <div className="flex-1 overflow-y-auto py-4 px-3">
        <nav className="space-y-1">
          {links.map((link) => {
            const Icon = link.icon;
            const isActive = pathname === link.href || pathname.startsWith(link.href);

            return (
              <Link
                key={link.href}
                to={link.href}
                className={cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors',
                  isActive
                    ? 'bg-sidebar-accent text-sidebar-foreground font-medium'
                    : 'text-sidebar-foreground/70 hover:bg-sidebar-accent/50 hover:text-sidebar-foreground'
                )}
              >
                <Icon className="h-4 w-4" />
                {link.label}
              </Link>
            );
          })}
        </nav>
      </div>

      <div className="border-t border-sidebar-border p-4">
        <button
          onClick={onLogout}
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm text-sidebar-foreground/70 hover:bg-sidebar-accent hover:text-sidebar-foreground transition-colors"
        >
          <LogOut className="h-4 w-4" />
          Sign out
        </button>
      </div>
    </aside>
  );
}
